import React, { useState, useEffect,useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import '../chatcss/ChatIcon.css';
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { Rnd } from 'react-rnd';

const ChatIcon = ({ SetChatBox }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [notification, setNotification] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const { allUsers, status, error } = useSelector((state) => state.users);


  const userMap = useMemo(
  () => new Map(
    allUsers.map(user => [user._id, user])
  ),
  [allUsers]
);
console.log(userMap,"userMapuserMapuserMapuserMapuserMapuserMapuserMapuserMapuserMap")
  // Get chat info from Redux
  const { chatInfo } = useSelector((state) => state.ui);
  const { user } = useSelector((state) => state.auth);

  const toggleChat = () => {
    SetChatBox(prev => !prev);
  };
console.log(notification,"notificationnotificationnotificationnotificationnotificationnotificationnotificationnotification")
  // Reset position to center-ish if user double-clicks
  const handleDoubleClick = () => {
    const centerX = window.innerWidth / 2 - iconWidth / 2;
    const centerY = window.innerHeight / 2 - iconHeight / 2;
    const newPos = { x: centerX, y: centerY };
    setPosition(newPos);
    savePosition(newPos);
    console.log('ChatIcon position reset to center:', newPos);
  };

  const iconWidth = 80;
  const iconHeight = 80;

  // Get saved position from localStorage or calculate default
  const getSavedPosition = () => {
    try {
      const saved = localStorage.getItem('chatIcon-position');
      if (saved) {
        const parsed = JSON.parse(saved);
        // Validate the saved position is still within screen bounds with safe margins
        const safeMargin = 10;
        const maxX = Math.max(window.innerWidth - iconWidth - safeMargin, safeMargin);
        const maxY = Math.max(window.innerHeight - iconHeight - safeMargin, safeMargin);
        const x = Math.min(Math.max(parsed.x, safeMargin), maxX);
        const y = Math.min(Math.max(parsed.y, safeMargin), maxY);
        return { x, y };
      }
    } catch (error) {
      console.warn('Error loading saved ChatIcon position:', error);
    }

    // Default position (conservative - not too far right)
    const x = Math.min(window.innerWidth - iconWidth - 100, window.innerWidth * 0.8);
    const y = Math.min(window.innerHeight - iconHeight - 100, window.innerHeight * 0.8);
    console.log('Using default ChatIcon position:', { x, y }, 'Screen:', { width: window.innerWidth, height: window.innerHeight });
    return { x, y };
  };

  // Save position to localStorage
  const savePosition = (pos) => {
    try {
      localStorage.setItem('chatIcon-position', JSON.stringify(pos));
    } catch (error) {
      console.warn('Error saving ChatIcon position:', error);
    }
  };

  // Initialize position and handle window resize
  useEffect(() => {
    const initPosition = getSavedPosition();
    console.log('ChatIcon initial position:', initPosition, 'Screen size:', { width: window.innerWidth, height: window.innerHeight });
    setPosition(initPosition);

    const handleResize = () => {
      setPosition(currentPos => {
        // Ensure position stays within new window bounds with safe margins
        const safeMargin = 10;
        const maxX = Math.max(window.innerWidth - iconWidth - safeMargin, safeMargin);
        const maxY = Math.max(window.innerHeight - iconHeight - safeMargin, safeMargin);
        const x = Math.min(Math.max(currentPos.x, safeMargin), maxX);
        const y = Math.min(Math.max(currentPos.y, safeMargin), maxY);
        const newPos = { x, y };
        savePosition(newPos);
        return newPos;
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Watch for new messages and show notifications
  useEffect(() => {
    if (chatInfo && chatInfo.unreadCounts) {
      const totalUnread = Object.values(chatInfo.unreadCounts).reduce((sum, count) => sum + count, 0);

      if (totalUnread > 0) {
        // Find the sender with unread messages
        const senderWithMessages = Object.entries(chatInfo.unreadCounts).find(([sender, count]) => count > 0);

        if (senderWithMessages) {
          const [senderId, count] = senderWithMessages;

          // You can enhance this by getting actual sender name from your user data
          // For now, using a placeholder or actual data if available
          const senderName = getSenderName(senderId);

          setNotification({
            senderName,
            count,
            message: count === 1 ? 'sent you a message' : `sent you ${count} messages`
          });
          setShowNotification(true);

          // Auto-hide notification after 5 seconds
          const timer = setTimeout(() => {
            setShowNotification(false);
          }, 5000);

          return () => clearTimeout(timer);
        }
      } else {
        setShowNotification(false);
      }
    }
  }, [chatInfo]);

  // Helper function to get sender name (you can enhance this)
const getSenderName = (senderId) => {
  const user = userMap.get(senderId);

  return user
    ? `${user.firstName} ${user.lastName}`
    : "Unknown User";
};

  // Calculate total unread count
  const getTotalUnreadCount = () => {
    if (chatInfo && chatInfo.unreadCounts) {
      return Object.values(chatInfo.unreadCounts).reduce((sum, count) => sum + count, 0);
    }
    return 0;
  };

  console.log("ChatIcon is rendering")
  const navigate = useNavigate();

  return (
    <Rnd
      position={position}
      size={{
        width: iconWidth,
        height: iconHeight,
      }}
      bounds="window"
      enableResizing={false}
      dragHandleClassName="chat-icon-button"
      className="mui-fixed"
      onDragStop={(e, data) => {
        const newPos = { x: data.x, y: data.y };
        setPosition(newPos);
        savePosition(newPos);
      }}
      style={{
        zIndex: 9999,
        position: 'fixed',
      }}
    >
      <div
        className="chat-icon-button"
        onClick={toggleChat}
        onDoubleClick={handleDoubleClick}
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: '#3b82f6',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)',
          transition: 'all 8s ease',
          position: 'relative',
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.1)';
          e.target.style.boxShadow = '0 6px 20px rgba(59, 130, 246, 0.6)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.4)';
        }}
      >
        {/* Show notification count badge */}
        {getTotalUnreadCount() > 0 && (
          <div className="notification-dot" style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            width: '20px',
            height: '20px',
            backgroundColor: '#ef4444',
            border: '2px solid white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '10px',
            fontWeight: 'bold',
            color: 'white',
            zIndex: 1,
          }}>
            {getTotalUnreadCount() > 99 ? '99+' : getTotalUnreadCount()}
          </div>
        )}

        <ChatBubbleOutlineIcon
          style={{
            color: 'white',
            fontSize: '32px'
          }}
        />

        {/* Real-time notification popup */}
        {showNotification && notification && (
          <div
            style={{
              position: 'absolute',
              bottom: '90px',
              right: '0px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              padding: '12px 16px',
              borderRadius: '12px',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
              minWidth: '280px',
              maxWidth: '320px',
              zIndex: 10000,
              animation: 'slideInFromRight 0.3s ease-out',
              border: '2px solid rgba(255, 255, 255, 0.2)'
            }}
            onClick={(e) => {
              e.stopPropagation();
              setShowNotification(false);
              toggleChat();
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '8px'
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '18px'
              }}>
                💬
              </div>
              <div style={{ flex: 1 }}>
                <div style={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  marginBottom: '4px'
                }}>
                  New Message!
                </div>
                <div style={{
                  fontSize: '13px',
                  opacity: 0.9
                }}>
                  {notification.senderName} {notification.message}
                </div>
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setShowNotification(false);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  fontSize: '16px',
                  cursor: 'pointer',
                  opacity: 0.7,
                  padding: '4px'
                }}
              >
                ✕
              </button>
            </div>

            <div style={{
              fontSize: '11px',
              opacity: 0.7,
              textAlign: 'center',
              borderTop: '1px solid rgba(255, 255, 255, 0.2)',
              paddingTop: '8px',
              marginTop: '8px'
            }}>
              Click to open chat
            </div>
          </div>
        )}
      </div>
    </Rnd>
  );
};

export default ChatIcon;
